import { Component, OnInit } from '@angular/core';
// import { GenericService } from '../services/generic.service';
import {ActivatedRoute } from '@angular/router';
import { ExternalApisService } from 'src/app/services/external-apis.service';
import { GlobalConstants } from '../global-constants';
import { SplashScreenStateService } from '../services/splash-screen-state-service';
// import { SpinnerComponent } from '../spinner/spinner.component';
 // import { SplashScreenStateService } from '../services/splash-screen-state-service';
@Component({
  selector: 'app-photo-detail',
  templateUrl: './photo-detail.component.html',
  styleUrls: ['./photo-detail.component.css']
})
export class PhotoDetailComponent implements OnInit {
  public theHtmlString ="";
  public photosPath = GlobalConstants.photosServerPath; 
  retItem: any;
  retItems: any;
  album:any;
  
  constructor(private route: ActivatedRoute,private externalApis: ExternalApisService,private splashScreenStateService: SplashScreenStateService) 
  { 

  }

  ngOnInit() {
    
    setTimeout(() => {
      this.splashScreenStateService.stop();
      
   }, 1500);

    this.route.params.subscribe( params => {console.log(params);
      this.album = params.id;
      this.LoadData(params.id);
    });


  }


  LoadData(id:any ) {
    
    this.externalApis.getPhotosByGallery(id).subscribe((data) => {
      this.retItem = data;

      console.log(this.retItem);
      // this.splashScreenStateService
        this.theHtmlString = this.retItem.html_content;
        this.splashScreenStateService.stop();
      
    }), 
    err => {
         console.log(err);
      }
  }
}
